import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
    minHeight: '52px',
    background: 'rgba(202, 202, 252, 0.15)',
    border: '1px dashed #3C419A',
    borderRadius: '3px',
  },
  dragText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#3C419A',
    width: '40%',
    textAlign: 'center',
  },
  hint: {
    fontSize: '12px'
  },
  fileText: {
    textDecoration: 'underline',
    fontWeight: 'bolder',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#3C419A',
    cursor: 'pointer'
  },
  input: {
    display: 'none',
  },
  dragZone: {
    border: '1px solid #3C419A',
    backgroundColor: 'rgba(255,255,255,.8)',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
  },
  dragContent: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    textAlign: 'center',
    color: 'grey',
    fontSize: '14px',
  },
  dropText: {
    fontSize: '14px',
    lineHeight: '16px',
    color: '#3C419A',
    textAlign: 'center',
  },
}));
